import { Button, Dropdown, Input, MenuProps, Space } from "antd";
import { UndoOutlined, MoreOutlined, CheckOutlined, DownloadOutlined } from "@ant-design/icons";
import { useState } from "react";

function SearchUser({
    keyWord,
    request,
    onClear,
    onSearch,
    setTableSize,
    onDownload,
    isDownloading,
}: {
    keyWord?: string;
    request: () => void;
    onClear: () => void;
    onSearch: (type: string, value: any) => void;
    setTableSize: (size: number) => void;
    onDownload?: () => void;
    isDownloading?: boolean;
}) {
    const [Label, setLabel] = useState([
        <span>
            10개 <CheckOutlined />
        </span>,
        <span>30개</span>,
        <span>50개</span>,
        <span>100개</span>,
    ]);
    const handleMenuClick: MenuProps["onClick"] = (e) => {
        setTableSize(Number(e.key));

        switch (e.key) {
            case "10":
                setLabel([
                    <span>
                        10개 <CheckOutlined />
                    </span>,
                    <span>30개</span>,
                    <span>50개</span>,
                    <span>100개</span>,
                ]);
                break;
            case "30":
                setLabel([
                    <span>10개</span>,
                    <span>
                        30개 <CheckOutlined />
                    </span>,
                    <span>50개</span>,
                    <span>100개</span>,
                ]);
                break;
            case "50":
                setLabel([
                    <span>10개</span>,
                    <span>30개</span>,
                    <span>
                        50개 <CheckOutlined />
                    </span>,
                    <span>100개</span>,
                ]);
                break;
            case "100":
                setLabel([
                    <span>10개</span>,
                    <span>30개</span>,
                    <span>50개</span>,
                    <span>
                        100개 <CheckOutlined />
                    </span>,
                ]);
                break;
        }
    };

    const items: MenuProps["items"] = [
        {
            label: Label[0],
            key: "10",
        },
        {
            label: Label[1],
            key: "30",
        },
        {
            label: Label[2],
            key: "50",
        },
        {
            label: Label[3],
            key: "100",
        },
    ];

    const menuProps = {
        items,
        onClick: handleMenuClick,
    };

    return (
        <div>
            <Space>
                <Input
                    placeholder="검색"
                    value={keyWord}
                    onChange={(e) => onSearch("keyWord", e.target.value)}
                    onKeyUp={(e) => e.key === "Enter" && request()}
                    allowClear
                ></Input>
                {onDownload && <Button type="primary" onClick={onDownload} icon={<DownloadOutlined />} loading={isDownloading} />}
                <Button type="primary" onClick={onClear}>
                    <UndoOutlined />
                </Button>
                <Dropdown menu={menuProps}>
                    <Space>
                        <MoreOutlined />
                    </Space>
                </Dropdown>
            </Space>
        </div>
    );
}

export default SearchUser;
